import { newRelicJSError } from "../../analytics/new_relic_helper";

// this function requires this: <script async src="https://www.googletagmanager.com/gtag/js?id={{@root.googleAdWordsId}}"></script>
// Event snippet for Pre-Client: Lead Form Submission conversion page
export function googleTagManagerTrackLead() {
	try {
		gtag('event',
			'conversion', {
				'send_to': '<%=googleAdWordsId%>/EfPFCL-7wW4QgdSD5QM'
			});
	} catch (err) {
		const error = "Error tracking lead form submission for Google Pixel: " + err;
		newRelicJSError(error);
		console.error(error);
	}
}

